module.exports = __webpack_public_path__ + "static/media/whatsapp-icon.8e32d517.svg";